/*
 * @Descripttion: banner组件
 * @Author: huangfuchunmei
 * @Date: 2023-08-29 15:56:48
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-10-30 16:54:42
 */
import React, { useRef, useState } from "react";
import styles from "./index.module.scss";
import BuyButton from "@/components/BuyButton";
import LazyMedia from "@/components/LazyMedia";
import { bannerPositon } from '@/common/const';
import { IBanner } from "@/common/types";

interface IProps {
  bannerList: IBanner[];
  ctry: string;
  words: Record<string, string>;
  device: string;
}

const Banner = (props: IProps) => {
  const { ctry, words, bannerList, device } = props;
  const [currBannerIndex, setCurrBannerIndex] = useState<number>(0); // 当前banner索引
  const [currBanner, setCurrBanner] = useState<IBanner>(bannerList[0]); // 当前banner
  const videoRef = useRef(null)

  // 鼠标划入切换banner
  const handleMouseEnter = (index: number) => {
    if (index !== currBannerIndex) {
      setCurrBannerIndex(index);
      setCurrBanner(bannerList[index]);
    }
    // if (videoRef.current) {
    //   videoRef.current.classList.add(styles["fide-in"]);
    // }
  };
  // const handleMouseLeave = (index: number) => {
  //   if (videoRef.current) {
  //     videoRef.current.classList.remove(styles["fide-in"]);
  //   }
  // };

    // 动画切换防抖
  const debounce = (func:any, delay:number) =>{
    let timerId:any;

    return function (...args:any) {
      clearTimeout(timerId);

      timerId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }
  const debouncedHandleMouseEnter = debounce(handleMouseEnter, 300);
  // const debouncedHandleMouseLeave = debounce(handleMouseLeave, 300);

  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)

  const defaultPositon: Record<string, Record<string, number>> = bannerPositon // 文字和按钮默认位置

  return (
    <>
      {bannerList && (
        <div className={styles["home-banner-wrap"]}>
          <div className={styles["banner-wrap"]}>
            {bannerList.length > 0 &&
              bannerList.slice(0, 3).map((item, index) => (
                <div style={{ opacity: index === currBannerIndex ? 1 : 0}} ref={videoRef} key={item.id}>
                  {
                    item[newDevice].extension === '.mp4'
                      ? <LazyMedia type="video" loop autoPlay preload="auto" playsInline muted src={item[newDevice]?.url}></LazyMedia>
                      : <LazyMedia type="image" src={item[newDevice]?.url} alt={item[newDevice]?.alt} />
                  }
                </div>
              ))}
          </div>
          <div className={styles["banner-content"]}>
            <div
              className={styles["title-wrap"]}
              style={{
                left: currBanner[newDevice]?.titleLeft ? currBanner[newDevice]?.titleLeft+'%' : defaultPositon[newDevice]?.titleLeft+'%',
                top: currBanner[newDevice]?.titleTop ? currBanner[newDevice]?.titleTop+'%' : defaultPositon[newDevice]?.titleTop+'%'
              }} >
                {currBanner?.isShowTitle === 1 && (
                  <h1 className={styles["banner-title"]}>{ currBanner?.name}</h1>
                )}
              <p className={styles["banner-sub-title"]}>{currBanner?.remark}</p>
            </div>
            <div
              className={styles["btn-wrap"]}
              style={{
                left: currBanner[newDevice]?.btnLeft ? currBanner[newDevice]?.btnLeft+'%' : defaultPositon[newDevice]?.btnLeft+'%',
                top: currBanner[newDevice]?.btnTop ? currBanner[newDevice]?.btnTop+'%' : defaultPositon[newDevice]?.btnTop+'%'
              }} >
              <BuyButton buyPaths={currBanner?.buyPaths} words={words} btnStyle={currBanner[newDevice]?.btnStyle} />
              {currBanner && currBanner.url && (
                <span
                  className={styles["learn-more-white"]}
                  onClick={() => {
                    window.open(currBanner.url);
                  }}
                >
                  {words?.common_learn_more}
                </span>
              )}
              {/* Learn More */}
            </div>
          </div>
          <div className={styles["banner-video-wrap"]}>
            <div className={styles["banner-video-list"]}>
              {bannerList.length > 0 &&
                bannerList.slice(0, 3).map((item, index) => (
                  <div
                    key={item.id}
                    className={styles["banner-video-list-item"]}
                    onMouseEnter={() => debouncedHandleMouseEnter(index)}
                  >
                    <div className={styles["video-wrap"]}>
                      {
                        item[newDevice].extension === '.mp4'
                        ? <LazyMedia type="video" loop preload="auto" playsInline muted src={item[newDevice]?.url}></LazyMedia>
                        : <LazyMedia type="image" src={item[newDevice]?.url} alt={item[newDevice]?.alt} />
                      }
                      <div
                        className={`${
                          currBannerIndex === index ? styles["active"] : ""
                        } ${styles["video-wrap-mark"]}`}
                      ></div>
                    </div>
                    {device !== "mobile" && (
                      <div className={styles["content-wrap"]}>
                        <h4>{item?.name}</h4>
                        <h5>{item?.remark}</h5>
                      </div>
                    )}
                    <div
                      className={`${
                        currBannerIndex === index
                          ? styles["default-line-active"]
                          : ""
                      }`}
                    ></div>
                  </div>
                ))}
              <div className={styles["default-line"]}></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Banner;
